const ANALYSIS_ACTIONS = {
  //get total user working analysis
  GET_TOTAL_USER_WORKING: "GET_TOTAL_USER_WORKING",
  GET_TOTAL_USER_WORKING_SUCCESS: "GET_TOTAL_USER_WORKING_SUCCESS",
  GET_TOTAL_USER_WORKING_FAIL: "GET_TOTAL_USER_WORKING_FAIL",
  //get current user working analysis
  GET_CURRENT_USER_WORKING: "GET_CURRENT_USER_WORKING",
  GET_CURRENT_USER_WORKING_SUCCESS: "GET_CURRENT_USER_WORKING_SUCCESS",
  GET_CURRENT_USER_WORKING_FAIL: "GET_CURRENT_USER_WORKING_FAIL",
  //get working chart
  GET_WORKING_CHART: "GET_WORKING_CHART",
  GET_WORKING_CHART_SUCCESS: "GET_WORKING_CHART_SUCCESS",
  GET_WORKING_CHART_FAIL: "GET_WORKING_CHART_FAIL",
  //get user analysis detail
  GET_USER_ANALYSIS_DETAIL: "GET_USER_ANALYSIS_DETAIL",
  GET_USER_ANALYSIS_DETAIL_SUCCESS: "GET_USER_ANALYSIS_DETAIL_SUCCESS",
  GET_USER_ANALYSIS_DETAIL_FAIL: "GET_USER_ANALYSIS_DETAIL_FAIL",
  //get user working days
  GET_USER_WORKING_DAYS: "GET_USER_WORKING_DAYS",
  GET_USER_WORKING_DAYS_SUCCESS: "GET_USER_WORKING_DAYS_SUCCESS",
  GET_USER_WORKING_DAYS_FAIL: "GET_USER_WORKING_DAYS_FAIL",
  //get user latency
  GET_USER_LATENCY: "GET_USER_LATENCY",
  GET_USER_LATENCY_SUCCESS: "GET_USER_LATENCY_SUCCESS",
  GET_USER_LATENCY_FAIL: "GET_USER_LATENCY_FAIL",
  //get user reason
  GET_USER_REASON: "GET_USER_REASON",
  GET_USER_REASON_SUCCESS: "GET_USER_REASON_SUCCESS",
  GET_USER_REASON_FAIL: "GET_USER_REASON_FAIL",
  //get user location analysis
  GET_USER_LOCATION_ANALYSIS: "GET_USEGET_USER_LOCATION_ANALYSISR_REASON",
  GET_USER_LOCATION_ANALYSIS_SUCCESS: "GET_USER_LOCATION_ANALYSIS_SUCCESS",
  GET_USER_LOCATION_ANALYSIS_FAIL: "GET_USER_LOCATION_ANALYSIS_FAIL",
};
export default ANALYSIS_ACTIONS;
